// DEPENDENCIES
import _ from 'lodash';

// UTILITY FUNCTIONS
export const getCodes = object => _.filter(object).map(({ code }) => code);
export const getByCode = (collection, code) => _.find(collection, o => o.code === code) || {};
export const getByNumeric = (collection, numeric) => _.find(collection, o => o.numeric === numeric) || {};

// VARIABLES
export const AM_PRODUCT_TYPE = {
  am: {
    label: 'Aftermarket Product (AM)',
    code: 'AM',
    numeric: 0
  },
  fi: {
    label: 'Finance Product (F&I)',
    code: 'F&I',
    numeric: 1
  }
};
export const AM_STATUS = {
  waiting: {
    icon: 'waiting',
    className: 'text-danger',
    label: 'Waiting for AM Assignment.'
  },
  assigned: {
    icon: 'assigned',
    className: 'text-warning',
    label: 'AM is assigned - Need to enter AM gross.'
  },
  completed: {
    icon: 'completed',
    className: 'text-success',
    label: 'Deal is completed and AM Gross entered.'
  }
};
export const ASSIGNMENT_STATUS = {
  Completed: {
    label: 'Completed',
    code: 'C',
    variant: 'success'
  },
  Assigned: {
    label: 'Assigned',
    code: 'A',
    variant: 'warning'
  },
  Waiting: {
    label: 'Waiting',
    code: 'W',
    variant: 'danger'
  }
};
export const DELIVERY_LOG_TYPE = {
  Delivered: {
    label: 'Delviered',
    code: 'D'
  },
  OverView: {
    label: 'OverView',
    code: 'O'
  }
};
export const FM_STATUS = {
  waiting: {
    icon: 'waiting',
    className: 'text-danger',
    label: 'Waiting for FM Assignment.'
  },
  assigned: {
    icon: 'assigned',
    className: 'text-warning',
    label: 'FM is assigned - Need to enter F&I Gross.'
  },
  completed: {
    icon: 'completed',
    className: 'text-success',
    label: 'Deal is completed and F&I Gross entered.'
  }
};
export const GLOBAL_LOCAL = {
  global: {
    label: 'Global',
    code: 'G',
    numeric: 1
  },
  local: {
    label: 'Local',
    code: 'L',
    numeric: 0
  }
};
export const GLOBAL_SEARCH = {
  Delivered: {
    label: 'Delivered ',
    code: 'Delivered',
    variant: 'success'
  },
  fallout: {
    label: 'Fallout ',
    code: 'Fallout',
    variant: 'danger'
  },
  backout: {
    label: 'Backout ',
    code: 'Backout',
    variant: 'danger'
  },
  returned: {
    label: 'Returned ',
    code: 'Returned',
    variant: 'secondary'
  },
  inStock: {
    label: 'In Stock ',
    code: 'In Stock',
    variant: 'secondary'
  },
  order: {
    label: 'Order ',
    code: 'Order',
    variant: 'highlight'
  },
  preStock: {
    label: 'Pre Stock ',
    code: 'Pre Stock',
    variant: 'warning'
  },
  sold: {
    label: 'Sold ',
    code: 'Sold',
    variant: 'highlight'
  },
  WsDelivered: {
    label: 'WS Delivered ',
    code: 'WS Delivered',
    variant: 'secondary'
  }
};
export const INVENTORY_SOURCE = {
  dealer: {
    label: 'Dealer DX',
    code: 'D'
  },
  manufacturer: {
    label: 'Manufacturer',
    code: 'M'
  },
  other: {
    label: 'Other',
    code: 'O'
  },
  purchase: {
    label: 'Purchase',
    code: 'P'
  },
  trade: {
    label: 'Trade',
    code: 'T'
  }
};
export const INVENTORY_STATUS = {
  preStock: {
    label: 'Pre Stock',
    code: 'PS',
    variant: 'warning'
  },
  order: {
    label: 'Order',
    code: 'O',
    variant: 'highlight'
  },
  inStock: {
    label: 'In Stock',
    code: 'I',
    variant: 'secondary'
  },
  sold: {
    label: 'Sold',
    code: 'S',
    variant: 'highlight'
  },
  fallout: {
    label: 'Fallout',
    code: 'F',
    variant: 'danger'
  },
  delivered: {
    label: 'Delivered',
    code: 'D',
    variant: 'success'
  },
  returned: {
    label: 'Returned',
    code: 'RET',
    variant: 'none'
  },
  backout: {
    label: 'Backout',
    code: 'B',
    variant: 'danger'
  }
};
export const INVENTORY_TYPE = {};
export const NEW_USED = {
  new: {
    label: 'New',
    code: 'N',
    numeric: 1
  },
  used: {
    label: 'Pre-Owned',
    code: 'P',
    numeric: 0
  },
  certifiedPreOwned: {
    label: 'Certified Pre-Owned (CPO)',
    code: 'C',
    numeric: 2,
    variant: 'success'
  }
};
export const PURCHASE_LEASE = {
  new: {
    label: 'Purchase',
    code: 'P'
  },
  used: {
    label: 'Lease',
    code: 'L'
  }
};
export const RETAIL_LEASE = {
  R: {
    label: 'Retail',
    code: 'R'
  },
  L: {
    label: 'Lease',
    code: 'L'
  }
};
export const RETAIL_WHOLESALE = {
  retail: {
    label: 'Retail',
    code: 'R',
    numeric: 1,
    category_code: 'RETAIL'
  },
  wholesale: {
    label: 'Wholesale',
    code: 'W',
    numeric: 2,
    category_code: 'WHOLESALE'
  }
};
export const DELIVERY_LOG_STATUS = {
  Delivered: {
    label: 'Delivered',
    code: 'D'
  },
  DeliveredBackoutCarryover: {
    label: 'Delivered/Backout/Carryover',
    code: 'D',
    className: 'text-danger'
  },
  Backout: {
    label: 'Backout',
    code: 'B',
    className: 'text-danger'
  },
  Carryover: {
    label: 'Carryover',
    code: 'C'
  }
};
export const SA_STATUS = {
  good: {
    icon: 'success',
    className: 'text-success'
  },
  'in-question': {
    icon: 'help',
    className: 'text-danger'
  },
  save: {
    icon: 'save',
    className: 'text-primary'
  }
};
export const SALE_SUBTYPE = {
  preOwnedStandard: {
    code: 'PS',
    label: 'Pre-Owned Standard'
  },
  certifiedPreOwnedStandard: {
    code: 'PS-CPO',
    label: 'Certified Pre-Owned Standard'
  },
  preOwenedLoaner: {
    code: 'PL',
    label: 'Pre-Owned Loaner'
  },
  certifiedLoaner: {
    code: 'PL-CPO',
    label: 'Certified Loaner'
  },
  newStandard: {
    code: 'NS',
    label: 'New Standard'
  },
  newDemo: {
    code: 'ND',
    label: 'New Demo'
  },
  newLoaner: {
    code: 'NL',
    label: 'New Loaner'
  },
  notAssigned: {
    code: 'NA',
    label: 'Not Assigned'
  }
};
export const SALES_STATUS = {
  sold: {
    code: 'S',
    label: 'Sold'
  },
  order: {
    code: 'O',
    label: 'Order'
  },
  fallout: {
    code: 'F',
    label: 'Fallout'
  },
  saleFromOrder: {
    code: 'AMFI',
    label: 'Sale From Order'
  }
};
export const WHOLESALE_FORMAT = {
  simplified: {
    label: 'Simplified',
    numeric: 1
  },
  detailed: {
    label: 'Detailed',
    numeric: 2
  }
};
